import { createContext } from '@framework';
import type { PdfEngine } from '@elhalawany/models';

export interface PdfEngineContextState {
  engine: PdfEngine | null;
  isLoading: boolean;
  error: Error | null;
}

export const PdfEngineContext = createContext<PdfEngineContextState | undefined>(undefined);
